(function () {
  const intro = {
    init() {
      this.$intro = document.querySelector('section.intro')

      if (this.$intro !== null) {
        if (window.innerWidth < 768) {
          this.$introVideo = this.$intro.querySelector('.mobile')
        } else {
          this.$introVideo = this.$intro.querySelector('.desktop')
        }

        this.$cta = this.$intro.querySelector('.cta_wrapper')

        // because this is the only way to reference it in removeEventList...
        this.videoEndBinded = this.videoEnd.bind(this)
        this.scrollDownBinded = this.scrollDown.bind(this)
        this.navBackBinded = this.navBack.bind(this)
        this.toggleVideoBinded = this.toggleVideo.bind(this)
        this.closeVideoBinded = this.closeVideo.bind(this)
        this.restartVideoBinded = this.restartVideo.bind(this)
        this.videoLoadedBinded = this.videoLoaded.bind(this)
        this.destroyBinded = this.destroy.bind(this)

        this.setUpListeners()
        this.setUpParallax()

        if (location.hash === '#play-video') {
          this.$introVideo
            .addEventListener('loadedmetadata', this.videoLoadedBinded)
        }
      }
    },

    setUpListeners() {
      PubSub.subscribe('page.transitionStartDone', this.destroyBinded)
      PubSub.subscribe('intro.close_video', this.closeVideoBinded)

      this.$intro
        .querySelectorAll('video')
        .forEach($video => {
          $video.addEventListener('click', this.toggleVideoBinded)
        })

      this.$intro
        .querySelector('.back_btn')
        .addEventListener('click', this.navBackBinded)

      this.$intro
        .querySelector('.scroll_down')
        .addEventListener('click', this.scrollDownBinded)

      if (this.$cta !== null) {
        this.$cta
          .querySelector('.restart')
          .addEventListener('click', this.restartVideoBinded)
      }
    },

    setUpParallax() {
      ScrollTrigger.create({
        id: 'video-parallax',
        trigger: this.$intro,
        start: () => {
          return window.innerHeight + ' ' + window.innerHeight
        },
        end: 'bottom top',
        // markers: true,
        onUpdate: ({progress}) => {
          gsap.set(this.$introVideo, {
            y: window.innerHeight / 3 * progress
          })

          gsap.set(this.$intro.querySelector('.title_wrapper'), {
            y: window.innerHeight / 3 * progress,
            opacity: (1 - progress)
          })
        }
      })
    },

    videoLoaded() {
      console.log('Video Loaded HANDLEEEEER')
      this.toggleVideo({}, false)
    },

    navBack() {
      history.back()
    },

    scrollDown() {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: window.innerHeight
      })
    },

    videoEnd() {
      if (this.$intro.querySelector('.cta_wrapper') !== null) {
        this.$cta.classList.add('active')
      } else {
        this.toggleVideo({}, true)
      }
    },

    restartVideo() {
      this.$cta.classList.remove('active')

      this.$introVideo.currentTime = 0
      this.$introVideo.play()
    },

    closeVideo() {
      this.toggleVideo({}, true)
    },

    toggleVideo(ev, toggler) {
      let isActive = toggler

      if (toggler === undefined) {
        isActive = this.$intro.classList.contains('active')
      }

      this.$introVideo.muted = isActive
      console.log('Toggler', isActive)

      if (!isActive) {
        this.$introVideo.loop = false
        this.$introVideo.currentTime = 0
        this.$introVideo.addEventListener('ended', this.videoEndBinded)

        gsap.to(window, {
          duration: 0.5,
          scrollTo: 0
        })
      } else {
        this.$introVideo.loop = true
        this.$introVideo.currentTime = 0
        this.$introVideo.removeEventListener('ended', this.videoEndBinded)
        this.$introVideo.play()
      }

      document.querySelector('.pointer_wrapper')
        .classList.toggle('playing', !isActive)

      this.$intro
        .classList.toggle('active', !isActive)

      PubSub.publish('header.toggle_video', isActive)
    },

    destroy() {
      const triggers = ScrollTrigger.getAll()
      console.log('Destroy: intro')

      PubSub.unsubscribe('page.transitionStartDone', this.destroyBinded)
      PubSub.unsubscribe('intro.close_video', this.closeVideoBinded)

      this.$intro
        .querySelectorAll('video')
        .forEach($video => {
          $video.removeEventListener('click', this.toggleVideoBinded)
        })

      this.$intro
        .querySelector('.back_btn')
        .removeEventListener('click', this.navBackBinded)

      this.$intro
        .querySelector('.scroll_down')
        .removeEventListener('click', this.scrollDownBinded)

      if (this.$cta !== null) {
        this.$intro
          .querySelector('.restart')
          .removeEventListener('click', this.restartVideoBinded)
      }

      this.$introVideo.removeEventListener('ended', this.videoEndBinded)

      triggers.forEach(trigger => {
        if (trigger.vars.id === 'video-parallax') {
          trigger.kill()
          console.log('Destroying video-parallax')
        }
      })

      ScrollTrigger.refresh()
        console.log('sdfsdfsdf', location.hash)

      this.$introVideo
        .removeEventListener('loadedmetadata', this.videoLoadedBinded)
    }
  }

  Object.assign(intro, window.tangleweb)

  intro.init()
  PubSub.subscribe('page.inDOM', intro.init.bind(intro))
})()
